export const Constants = {
  RestaurantReservation: {
    fee: 1000,
  },
  // 共通定数(例）notionリンク
  Notion: {
    // notionリンク
    MidnightRestaurant:
      "https://help.pato.today/232ba64478044c40927f925cdd79e494",
  },
  WebTrackToken: {
    TikTok: [
      "LG61hkZ9EoDscA8f49rqxpknnO9txXg_ox4QKhXPt0ybVdfZME3z8CDK2OLdN-L0hyo9jKsMCac0twFC0Kla6w",
      "ibZiYZjelfdhNvjr1kWlgavhuHtkADqHk33iTLrMH0xrTmoJEglJo037r4gWkawrsZfoiaGL6bgns8GI-q3y0g",
      "NOcoaikBY7EoOdCoSFHZ3dv9WJon4T9EOp4z3BxbTGHqe74ATLN9Z_HpT-JNwE6I-zPsSLH4aixb6EhPi8YHrQ",
      "Y63_648Bw5DcJFxbV_3pDgtbMt8H2YIeAFcoJP3OeTy-iQYezuFsQCrwoXM2_XkkSRdmzEh8gS5X0trB66Xtrw",
      "uH6yDqt24nwMzuUQJEXd_kd-T9pBcYh8rc6t9MaFEcZeP01EMk9jvS1W3iosTFMSq1CNtlJglEjXv7XY0v_-CQ",
      "Fp7v-IRsgjWBdyWZyYMt5_y0IGU0oozAJjxEy61eEIjv3EBewD95NYnMZi74f5faXofcddboaAzO6RYWVSIDPg",
      "iRHVofPnoXC6aPuQeulYavBZ4jfuzdyjvDs38LY51OyMq6fmTYXnx4KQL-ZxChOfy76YYbRas3TKIxoWgrqhhQ",
      "nkD4n4WCoVnOKA6RPkZhz5kkzblINV8w90p2Kx7HyEdemkF1LtrnV8S4Y0MEnCQxrZFIuwm-orxNy5SLyVyYzQ",
    ],
  },
};
